export default "__VITE_ASSET__BK5eqxfu__"